import './wdyr.ts'
import 'react-hot-loader'
import {hot} from 'react-hot-loader/root.js'
import React from 'react'
import ReactDOM from 'react-dom'
import './styling/index.css'
import * as serviceWorker from './serviceWorker'
import 'bootstrap/dist/css/bootstrap.min.css'
import App from './App/App'
import { Provider } from 'react-redux'
import store from './redux'

const HotApp = hot(App);
ReactDOM.render(
  <Provider store={store}>
    {/*<React.StrictMode> todo should add back and fix issues*/}
    <HotApp />
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers here: https://bit.ly/CRA-PWA
serviceWorker.unregister()
